import { EventTypes } from '../shared/EventTypes';
import { AppEventDispatcher } from '../utils/AppEventDispatcher';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ThemeService } from '../shared/theme-service/theme.service';
import { CustomerServiceService } from './customer-service/customer-service.service';
import { Auth } from '../autentication/Auth';
import { User } from '../autentication/models/user';
import { stat } from 'fs';

@Injectable()
export class MasterGuard implements CanActivate {
	constructor(
		private router: Router,
		private themeService: ThemeService,
		private customerServiceService: CustomerServiceService) {
	}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

		const isAttendant = this.themeService.isAttendant();
		const inAttendance = this.customerServiceService.getAccountsClientList().length > 0;
		const user: User = Auth.getInstance().getUser();

		if (!state.url.includes('servico-de-atendimento') && isAttendant && !inAttendance) {
			this.router.navigate(['servico-de-atendimento']);
			return false;
		}

		if (state.url.includes('pix') && !user.accessPix) {
			this.router.navigate(['']);
			return false;
		} else {
			return true;
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/master.guard.ts